import queryBuilder from '@glittr/frontend-core/src/plugins/validation/queryBuilder';
import UploadDocumentRequestModel from '../../../generated/types/model/request/UploadDocumentRequestModel';

export default class UploadDocumentRequestViewModel extends UploadDocumentRequestModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
